import * as accounts from "./modules/accounts";
import * as fretboards from "./modules/fretboards";
import * as preferences from "./modules/preferences";
import * as routing from "./modules/routing";

export const modules = { accounts, fretboards, preferences, routing };

export const state = {};
